import { render } from "./PerformanceChart5.vue?vue&type=template&id=511413d4&ts=true"
import script from "./PerformanceChart5.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart5.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__